import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main className="policy-page privacy">
      <header>
        <p className="eyebrow">Legal</p>
        <h1>Privacy policy</h1>
        <p>
          This policy explains how {siteConfig.displayName} handles information
          when you browse, place an order or contact our team. The data controller
          is {siteConfig.legalEntity.name}, registered at {siteConfig.legalEntity.address}.
        </p>
        <small>Last updated: 14 September 2026</small>
      </header>
      <article className="policy-copy">
        <section>
          <h2>Information we collect</h2>
          <p>
            We may collect contact, delivery, order and payment-status information
            that you provide during checkout or client-service conversations. We
            also receive limited technical data needed to operate and protect the
            storefront.
          </p>
        </section>
        <section>
          <h2>How we use information</h2>
          <p>
            Information is used to fulfil orders, provide support, prevent fraud,
            improve the store and send marketing only when you have chosen to
            receive it. This frontend demonstration stores bag and wishlist data
            locally in your browser.
          </p>
        </section>
        <section>
          <h2>Sharing &amp; retention</h2>
          <p>
            In a connected commerce service, necessary data may be shared with
            payment, delivery, hosting and professional-service providers under
            appropriate safeguards. Data is kept only as long as required for the
            stated purpose or by law.
          </p>
        </section>
        <section>
          <h2>Your choices</h2>
          <p>
            Depending on your location, you may request access, correction,
            deletion, restriction or portability, and may withdraw marketing
            consent at any time.
          </p>
        </section>
        <section>
          <h2>Cookies &amp; browser storage</h2>
          <p>
            Essential browser storage remembers bag and wishlist selections.
            Read our cookie policy for details and browser-control options.
          </p>
        </section>
        <section>
          <h2>Security</h2>
          <p>
            Reasonable technical and organisational measures are used to protect
            information. No online service can guarantee absolute security.
          </p>
        </section>
        <section>
          <h2>Children</h2>
          <p>
            This storefront is not directed to children, and we do not knowingly
            collect personal information from children through the shopping flow.
          </p>
        </section>
        <section>
          <h2>Contact</h2>
          <p>
            Privacy questions can be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.
          </p>
        </section>
      </article>
    </main>
  );
}

export default Privacy;
